/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeBlockFormatLevels.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Block Format Level Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, November 14, 2018 - 01:04:57 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      11/14/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const BLOCKFORMATLEVEL_LIST_CONTAINER_LOADED = 'BLOCKFORMATLEVEL_LIST_CONTAINER_LOADED';
export const BLOCKFORMATLEVEL_LIST_CONTAINER_UNLOADED = 'BLOCKFORMATLEVEL_LIST_CONTAINER_UNLOADED';
export const BLOCKFORMATLEVEL_LIST_TABLE_LOADED = 'BLOCKFORMATLEVEL_LIST_TABLE_LOADED';
export const BLOCKFORMATLEVEL_LIST_TABLE_UNLOADED = 'BLOCKFORMATLEVEL_LIST_TABLE_UNLOADED';

export const BLOCKFORMATLEVEL_LIST_CHANGE_GROUP = 'BLOCKFORMATLEVEL_LIST_CHANGE_GROUP';
export const BLOCKFORMATLEVEL_SELECT_ROW = 'BLOCKFORMATLEVEL_SELECT_ROW';

export const BLOCKFORMATLEVEL_ADD = 'BLOCKFORMATLEVEL_ADD';
export const BLOCKFORMATLEVEL_EDIT = 'BLOCKFORMATLEVEL_EDIT';
export const BLOCKFORMATLEVEL_DELETE = 'BLOCKFORMATLEVEL_DELETE';
export const BLOCKFORMATLEVEL_OPEN_WARNING = 'BLOCKFORMATLEVEL_OPEN_WARNING';
export const BLOCKFORMATLEVEL_CLOSE_WARNING = 'BLOCKFORMATLEVEL_CLOSE_WARNING';
export const BLOCKFORMATLEVEL_DELETE_DISABLE = 'BLOCKFORMATLEVEL_DELETE_DISABLE';

export const BLOCKFORMATLEVEL_EDIT_CONTAINER_LOADED = 'BLOCKFORMATLEVEL_EDIT_CONTAINER_LOADED';
export const BLOCKFORMATLEVEL_EDIT_CONTAINER_UNLOADED = 'BLOCKFORMATLEVEL_EDIT_CONTAINER_UNLOADED';
export const BLOCKFORMATLEVEL_EDIT_FORM_LOADED = 'BLOCKFORMATLEVEL_EDIT_FORM_LOADED';
export const BLOCKFORMATLEVEL_EDIT_FORM_UNLOADED = 'BLOCKFORMATLEVEL_EDIT_FORM_UNLOADED';

export const BLOCKFORMATLEVEL_SET_GROUP_SELECT = 'BLOCKFORMATLEVEL_SET_GROUP_SELECT';
export const BLOCKFORMATLEVEL_EDIT_DATA_LOAD = 'BLOCKFORMATLEVEL_EDIT_DATA_LOAD';

export const BLOCKFORMATLEVEL_EDIT_CONTAINER_SUBMIT = 'BLOCKFORMATLEVEL_EDIT_CONTAINER_SUBMIT';
export const BLOCKFORMATLEVEL_EDIT_CONTAINER_CANCEL = 'BLOCKFORMATLEVEL_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeBlockFormatLevels.js